import React, { useEffect } from "react";
import { Button } from "antd";
import HelperText from "../../../../components/HelperText/HelperText";

// Add Rewardful type declaration
declare global {
  interface Window {
    _rwq: any;
    rewardful: any;
  }
}

const Subscription = (props: any) => {
  const { userData } = props;

  useEffect(() => {
    // Initialize Rewardful
    const initRewardful = () => {
      const w = window as any;
      w._rwq = 'rewardful';
      w.rewardful = w.rewardful || function() {
        (w.rewardful.q = w.rewardful.q || []).push(arguments);
      };
    };
    initRewardful();

    const rewardfulScript = document.createElement("script");
    rewardfulScript.src = 'https://r.wdfl.co/rw.js';
    rewardfulScript.setAttribute('data-rewardful', '6326d5');
    rewardfulScript.async = true;
    document.head.appendChild(rewardfulScript);
  }, []);

  return (
    <div className="account-tile subscription">
      <div className="account-tile-header">
        <div className="account-tile-title">
          <p>Subscription</p>
          <HelperText message="This is the subscription status of your account." />
        </div>
      </div>
      <div className="account-tile-value">
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ fontWeight: 600, color: '#111827' }}>{userData?.payment_status}</span>
          <div style={{ 
            backgroundColor: 'rgba(36, 70, 240, 0.08)', 
            borderRadius: '6px', 
            padding: '0.75rem', 
            fontSize: '0.875rem' 
          }}>
            <p style={{ margin: 0, color: '#2446f0' }}>
              {userData?.payment_status === "Growth" 
                ? "You're enjoying premium features!" 
                : "Upgrade to unlock more features."}
            </p>
          </div>
        </div>
      </div>
      <div className="account-tile-action" style={{ marginTop: '-10px' }}>
        <a
          href="https://payments.searchbubble.com/p/login/14kg1ecrU8Lt8vK4gg"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <Button
            className="accountButton"
            id="manage-subscription"
            style={{ width: '100%' }}
          >
            Manage Subscription
          </Button>
        </a>
      </div>
    </div>
  );
};

export default Subscription;
